import rgba from 'color-alpha'

import { LG_MIN, MD_MIN, SM_MIN, XL_MIN, SIDEBAR_MAX } from './BreakPoints'

export const Theme = {
  colors: {
    'navy.100': '#03325B',
    'navy.75': '#426584',
    'navy.50': '#8199AD',
    'navy.25': '#C0CCD6',
    'navy.10': '#E6EBEF',

    'blue.100': '#48ACF0',
    'blue.75': '#76C1F4',
    'blue.50': '#A4D6F8',
    'blue.25': '#D1EAFB',
    'blue.10': '#EDF7FE',

    'green.100': '#1DBF83',
    'green.75': '#56CFA2',
    'green.50': '#8EDFC1',
    'green.25': '#C7EFE0',
    'green.10': '#E8F9F3',

    'orange.100': '#F29B4A',
    'orange.75': '#F5B477',
    'orange.50': '#F9CDA5',
    'orange.25': '#FCE6D2',
    'orange.10': '#FEF5ED',

    'yellow.100': '#FFD000',
    'yellow.75': '#FFDC40',
    'yellow.50': '#FFE880',
    'yellow.25': '#FFF3BF',
    'yellow.10': '#FFFAE6',

    'purple.100': '#7A52A1',
    'purple.75': '#9B7DB9',
    'purple.50': '#BDA9D0',
    'purple.25': '#DED4E8',
    'purple.10': '#F2EEF6',

    'red.100': '#F24A4A',
    'red.75': '#F57777',
    'red.50': '#F9A5A5',
    'red.25': '#FCD2D2',
    'red.10': '#fEEDED',

    transparent: 'transparent',
    'transparent.15': rgba('#FFFFFF', 0.15),
    'transparent.50': rgba('#FFFFFF', 0.5),
    'transparent.90': rgba('#FFFFFF', 0.9),

    'white.100': '#FFFFFF',
    background: '#F2F5F7',
    // temporary - update after Table or ListItem is created in Figma
    light: '#FAFBFC',
  },

  spacings: {
    xxxs: '1px',
    xxs: '2px',
    xs: '4px',
    sm: '8px',
    md: '16px',
    lg: '24px',
    xl: '32px',
    xxl: '48px',
    xxxl: '64px',

    // this is example if we need another dimension to add
    // generally this shouldn't be used, it's only temporary
    // to make old designs work with new designs
    // 🙏 use with caution (abs -> absolute)
    'abs.0': '0px',
    'abs.6': '6px',
    'abs.10': '10px',
    'abs.12': '12px',
    'abs.20': '20px',
    'abs.28': '28px', // height of mini segment controller
    'abs.30': '30px',
    'abs.40': '40px',
  },

  typography: {
    fontFamilies: {
      default: 'Open Sans',
    },
    fontSizes: {
      xxs: '12px',
      xs: '14px',
      sm: '16px',
      md: '20px',
      lg: '24px',
    },
    lineHeights: {
      xxs: '16px',
      xs: '18px',
      sm: '22px',
      md: '26px',
      lg: '30px',
    },
    fontWeights: {
      regular: 400,
      semiBold: 600,
    },
  },
  mq: {
    minWidth: {
      sm: `(min-width: ${SM_MIN}px)`,
      md: `(min-width: ${MD_MIN}px)`,
      lg: `(min-width: ${LG_MIN}px)`,
      xl: `(min-width: ${XL_MIN}px)`,
    },
    sideBarCollapsed: `(max-width: ${SIDEBAR_MAX}px)`,
  },
} as const

export const ColorEntries = Object.entries(Theme.colors)
export const ColorsKeys = Object.keys(Theme.colors)
export const SpacingKeys = Object.keys(Theme.spacings)
export const FontSizeKeys = Object.keys(Theme.typography.fontSizes)

export type ThemeType = typeof Theme
export type ThemeSpacing = keyof ThemeType['spacings']
